import React from "react";
import StaticPageForm from "./StaticPageForm";

export default function ViewStaticPage({ name }) {
    return (
        <StaticPageForm type="VIEW" />
    );
}
